import React, { memo, useCallback } from 'react'

import {
  Button,
  Icon,
  AIGenerated,
  CubeEditOutline,
  CubeOutline,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setActiveMobilePanel } from 'Pods/ThreeDStudio/Store/actions/ui'
import { MOBILE_PANEL } from 'Pods/ThreeDStudio/Store/constants'

const TABS = [
  { panel: MOBILE_PANEL.GENERATE, labelKey: 'mobileTabBar.tabs.generate', icon: AIGenerated },
  { panel: MOBILE_PANEL.VIEWER, labelKey: 'mobileTabBar.tabs.viewer', icon: CubeOutline },
  { panel: MOBILE_PANEL.ENHANCE, labelKey: 'mobileTabBar.tabs.enhance', icon: CubeEditOutline },
]

function MobileTabBar({ isModelOpened = false }) {
  const t = useTranslation()
  const activeMobilePanel = useThreeDStudioStore(state => state.ui?.activeMobilePanel)

  const handleSelect = useCallback((panel) => {
    setActiveMobilePanel(panel)
  }, [])

  return (
    <div className="mobile-tab-bar" role="tablist" aria-label="3D Studio panels">
      <div className="mobile-tab-bar__tabs">
        {TABS.map(({ panel, labelKey, icon }) => {
          const isActive = activeMobilePanel === panel
          const isDisabled = panel === MOBILE_PANEL.ENHANCE && !isModelOpened

          return (
            <Button
              key={panel}
              type="ghost"
              size="small"
              variant="with-icon"
              actionType="button"
              role="tab"
              aria-selected={isActive}
              disabled={isDisabled}
              isActive={isActive}
              customClass="mobile-tab-bar__tab cgt-body-base-semibold"
              onClick={isDisabled ? undefined : () => handleSelect(panel)}
              icon={
                <Icon
                  svgComponent={icon}
                  color="dark"
                  size={iconSizeMedium}
                  notSpaced
                  disabled={isDisabled}
                />
              }
            >
              {t(labelKey)}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

MobileTabBar.propTypes = {
  isModelOpened: bool,
}

export default memo(MobileTabBar)
